import React from "react";
import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { getPlan, updatePlan } from "../../../../../apis/options/PlanApi";
import './AddPlanStyles.css';
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { Card } from "react-bootstrap";

const schema = yup
  .object({
    name: yup.string().required(),
    maxPlanOptions: yup.number().positive().integer().required(),
    startDate: yup.date().required(),
    endDate: yup.date()
      .transform((value, originalValue) =>
        originalValue === '' ? null : value
      ).nullable().notRequired(),
    optionsExpireAfterInYears: yup.number().positive().integer().required()
  })
  .required()


const EditPlanForm = () => {

  let history = useHistory();
  const { planId } = useParams();

  const [plan, setPlan] = useState(null);
  const [planLoading, setPlanLoading] = useState(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    async function loadPlan() {
        try {
            const p = await getPlan(planId);
            if(p.startDate){
              p.startDate = moment(p.startDate).format("yyyy-MM-DD");
            }

            setPlan(p);
            setPlanLoading(false);
        }
        catch(error) {
            setPlanLoading(false);
        }
    }

    loadPlan();

  }, [planId]);


  const update = (data) => 
  {
    updatePlan(planId, data)
    .then( _ => {
      history.push(`/options/plans/${planId}`);
    })
    .catch( _ => {
      history.push(`/options/plans/${planId}`);
    });
  }

  const handleCancel = _ =>
  {
    history.push(`/options/plans/${planId}`);
  }

  return (
    <>
      {!planLoading ?
        <Card style={{ width: '18rem' }}>
          <Card.Body>
            <Card.Title>Edit Plan</Card.Title>
            <Card.Text>
              <Form noValidate 
                  onSubmit={handleSubmit(update)}>

                  <Form.Group>
                    <Form.Label>Plan Name</Form.Label>
                    <Form.Control defaultValue={plan.name} isInvalid={!!errors.name} type="text" placeholder="Plan Name" {...register("name")} />
                    <Form.Control.Feedback type="invalid">
                      {errors.name?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Maximum Options Available</Form.Label>
                    <Form.Control defaultValue={plan.maxPlanOptions} isInvalid={!!errors.maxPlanOptions} type="text" placeholder="Max Options Available" {...register("maxPlanOptions")} />
                    <Form.Control.Feedback type="invalid">{errors.maxPlanOptions?.message}</Form.Control.Feedback>
                  </Form.Group>                  
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control defaultValue={plan.startDate} isInvalid={!!errors.startDate} type="date" placeholder="Start Date" {...register("startDate")} />
                    <Form.Control.Feedback type="invalid">{errors.startDate?.message}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control defaultValue={plan.endDate} isInvalid={!!errors.endDate} type="date" placeholder="End Date" {...register("endDate")} />
                    <Form.Control.Feedback type="invalid">{errors.endDate?.message}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Options Expire After</Form.Label>
                    <Form.Control defaultValue={plan.optionsExpireAfterInYears} isInvalid={!!errors.optionsExpireAfterInYears} type="text" placeholder="Options Expire After" {...register("optionsExpireAfterInYears")} /> (in years)
                    <Form.Control.Feedback type="invalid">{errors.optionsExpireAfterInYears?.message}</Form.Control.Feedback>
                  </Form.Group>       
                  <Button variant="primary" type="submit">
                    Save
                  </Button>
                  <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                  </Button>
              </Form>
            </Card.Text>
          </Card.Body>
        </Card>        
        
      
        :<div>Loading...</div>
      }    
    </>
  );
}

export default EditPlanForm;